module.exports = __webpack_public_path__ + "img/prince_photo.a13cc9be.png";